import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';

export const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'WithoutOverlay') {
    return 'WithoutOverlay';
  }
  return undefined;
});

export default createComponentMapperModel({ uiType });
